import { flame, sword } from '../motifs';
import { M } from '../palette';
import { registerPlate } from '../registry';

/** 04 นักรบ: the warrior's plate, a burning blade on black lacquer, flames licking the right end. */
registerPlate({
  id: 'warrior',
  name: 'นักรบ',
  ground: ['#3a2622', '#22181a', '#140e10'],
  trim: M.goldLo,
  text: { fill: ['#ffd27a', '#f0782a'], line: '#140a08' },
  inset: [17, 13],
  front(p, f) {
    flame(p, f.x + 4, f.b + 3, 30, 13, 2);
    flame(p, f.x + 12, f.y + 8, 16, 8, -1);
    sword(p, [f.x - 3, f.b + 7], [f.x + 10, f.y - 7], { grip: 5, blade: ['#ffe9c0', '#d0a080', '#8a5040'] });
    flame(p, f.r - 4, f.b + 2, 30, 13, 2);
    flame(p, f.r + 3, f.b - 1, 16, 8, 1);
  },
  motion: {
    sprites: {
      tongueA: { w: 7, h: 12, draw: (p) => flame(p, 3.5, 12, 11, 6, 1) },
      tongueB: { w: 7, h: 12, draw: (p) => flame(p, 3.5, 12, 9, 6, -1) },
      ember: { w: 1, h: 1, draw: (p) => p.px(0, 0, '#ffd25a') },
    },
    play(a, t, f) {
      // Two tongues that trade places, flickering over the still flames.
      const n = Math.floor(t * 8) % 2;
      a.spr(n ? 'tongueA' : 'tongueB', f.r - 8, f.y - 6);
      a.spr(n ? 'tongueB' : 'tongueA', f.x + 1, f.y - 8);
      for (let i = 0; i < 4; i++) {
        const ph = (t * 0.7 + i / 4) % 1;
        const x = (i % 2 ? f.r - 6 : f.x + 3) + Math.sin((t + i) * 5) * 2 + i;
        a.spr('ember', x, f.y - 2 - ph * 14, 1 - ph);
      }
    },
  },
});
